<template>
  <div v-if="isBlinkNotAllowed">
    <div class="wrap">
      <div class="dots">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
      <div class="top-line d-flex align-center">
        <img
          :src="require(`../../assets/img/globe.svg`)"
          alt=""
          class="globe pr-2"
        >
        <span>www.huntica.ai</span>
        <img
          :src="require(`../../assets/img/camera-x.svg`)"
          alt=""
          class="camera"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api';
import useBrowser from '../../compositions/useBrowser';

export default {
  name: 'BlinkNotAllowedWindow',
  props: {
    errorObj: {
      required: true,
    },
  },
  setup(props) {
    const { errorObj } = toRefs(props);
    const {
      browser, browserMap, osMap, engineMap,
    } = useBrowser();

    const isBlinkNotAllowed = computed(() => errorObj.value.name.toLowerCase() === 'notallowederror'
      && !(browser.value.browser.name === browserMap.value.firefox)
      && !(browser.value.os.name === osMap.value.MacOS && errorObj.value.message.toLowerCase().indexOf('system') > -1)
      && !(browser.value.os.name === osMap.value.Windows && errorObj.value.message.toLowerCase().indexOf('system') > -1)
      && !(browser.value.browser.name === browserMap.value.safari && browser.value.os.name === osMap.MacOS)
      && !(browser.value.os.name === osMap.value.Android && browser.value.browser.name === browserMap.chrome)
      && (browser.value.engine.name === engineMap.value.Blink));

    return {
      browser,
      browserMap,
      osMap,
      engineMap,
      isBlinkNotAllowed,
    };
  },
};
</script>

<style lang="scss">
.wrap {
  max-width: 670px;
  background: #F7F7F7;
  border-radius: 8px;
  padding: 35px 20px 20px 20px;
  position: relative;
  color: #212121;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.43;
  margin: 0 auto;
}

.dots {
  display: flex;
  position: absolute;
  top: 12px;
  left: 20px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #C4C4C4;
  margin-right: 4px;
}

.top-line {
  background: #FFFFFF;
  padding: 6px 13px;
  border-radius: 4px;
  margin-bottom: 0;
  position: relative;

&:after {
   content: '';
   width: 77px;
   height: 77px;
   opacity: 0.2;
   border: 2px solid #ED2323;
   border-radius: 50%;
   position: absolute;
   right: -12px;
 }
}
.camera {
  position: absolute;
  top: 10px;
  right: 16px;
}
</style>
